export type AssististFeatureType = 'tripist' | 'explorist' | 'aura' | string;

export interface AssististDocumentLabels {
  singular: string;
  plural: string;
  subtitleLabel: string;
}

export function getAssististDocumentLabels(featureType: AssististFeatureType): AssististDocumentLabels {
  if (featureType === 'explorist') {
    return {
      singular: 'Product',
      plural: 'Products',
      subtitleLabel: 'Subtitle',
    };
  }

  if (featureType === 'aura') {
    return {
      singular: 'Inventory',
      plural: 'Inventory',
      subtitleLabel: 'Subtitle',
    };
  }

  return {
    singular: 'Place',
    plural: 'Places',
    subtitleLabel: 'Address',
  };
}
